import React, { useEffect, useState } from "react";
import {
  IDataPlantilla,
  IPostDetallePlantilllaVerificacion,
  IPostEditarPlantillaVerificacion,
} from "../../Interfaces/ListaVerificacion/PlantillaVerificacionDetalle/IPlantillaVerificacionDetalle";
import PlantillaVerificacionDetalleService from "../../services/ListaVerificacion/PlantillaVerificacionDetalleService";
import { IResponsePost } from "../../Interfaces/base/IResponse";

export const useEditarPlantiallaVerificacionDetalle = (
  isOpen: boolean,
  plantillaListaVerificacionId: string | undefined
) => {
  const [responseDataDetalle, setResponseDataDetalle] =
    useState<IDataPlantilla>(null!);
  const [response, setResponse] = useState<IResponsePost>(null!);
  const [loading, setLoading] = useState(false);

  const PostDetallaPlantillaVerificacion = (id: string | undefined) => {
    let data: IPostDetallePlantilllaVerificacion = {
      plantillaVerificacionId: id,
    };
    PlantillaVerificacionDetalleService.PostListarPlantillaVerificacionDetalle(
      data
    ).then((res) => {
      if (res.status === 200) {
        setResponseDataDetalle(res.data);
      }
    });
  };

  const PostEditarPlantillaVerificacionDetalle = (
    data: IPostEditarPlantillaVerificacion
  ) => {
    setLoading(true);
    PlantillaVerificacionDetalleService.PostEditarPlantillaVerificacionDetalle(
      data
    ).then((res) => {
      if (res.status === 200) {
        setResponse(res.data);
         PostDetallaPlantillaVerificacion(plantillaListaVerificacionId)
        setLoading(false);
      } else {
        setLoading(false);
      }
    });
  };

  useEffect(() => {
    if (isOpen && plantillaListaVerificacionId) {
      PostDetallaPlantillaVerificacion(plantillaListaVerificacionId);
    } else {
      setResponseDataDetalle(null!);
    }
  }, [isOpen, plantillaListaVerificacionId]);

  return {
    PostDetallaPlantillaVerificacion,
    responseDataDetalle,
    PostEditarPlantillaVerificacionDetalle,
    response,
    loading,
  };
};
